import { LabourHours } from "@stories/pages/Contractor/LabourHours/LabourHours";

export const LabourHoursView = () => {
  return <LabourHours />;
};
